import * as React from 'react';

// TODO: pass the shape of the context
const { Provider, Consumer } = React.createContext({});

export { Provider, Consumer };
